import classNames from 'classnames';
import { ReactElement, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import IconWrapper from '../IconWrapper';
import './style.scss';

type NavGroupItemProps = {
  to: string;
  children: ReactNode;
  icon?: ReactElement;
  showText?: boolean;
  disabled?: boolean;
};

const NavGroupItem = ({
  to,
  children,
  icon,
  showText = true,
  disabled = false
}: NavGroupItemProps) => {
  const anchorClass = classNames('nav-link text-white d-flex align-items-center gap-3', {
    disabled
  });

  return (
    <li className="nav-item">
      <Link to={to} className={anchorClass}>
        {icon ? (
          <IconWrapper size={24} color="text-white">
            {icon}
          </IconWrapper>
        ) : null}
        {showText && children}
      </Link>
    </li>
  );
};

export default NavGroupItem;
